import React from 'react';

// Reusable "Technology You Will Learn" grid section used across all program pages.
const TechStackSection = ({ title = 'Technology You Will Learn', accentColor = '#2563EB', bg = '#fff', border = '#E2E8F0', techs = [] }) => (
  <section style={{ padding: '60px 4%', background: bg, borderTop: `1px solid ${border}` }}>
    <div style={{ maxWidth: 1280, margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', fontSize: 24, fontWeight: 900, color: accentColor, letterSpacing: '0.04em', margin: '0 0 36px', textTransform: 'uppercase' }}>{title}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(90px,1fr))', gap: 16 }}>
        {techs.map((t) => (
          <div key={t.name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, textAlign: 'center' }}>
            <div style={{ width: 46, height: 46, borderRadius: 10, background: t.bg, border: `1.5px solid ${t.color}30`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: t.abbr && t.abbr.length > 2 ? 10 : 16, fontWeight: 900, color: t.color }}>
              {t.icon ? <t.icon size={22} color={t.color} /> : t.abbr}
            </div>
            <span style={{ fontSize: 10.5, fontWeight: 600, color: '#374151', lineHeight: 1.3 }}>{t.name}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TechStackSection;
